import H5Video from './h5video.vue'
export default H5Video